<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Fator de ponderação</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" style="width: 70%">Item</th>
            <th class="table-header" style="width: 30%">Fator de ponderação</th>
          </tr>
        </ng-container>
        <ng-container corpo *ngFor="let dados of dadosTabela; index as i">
          <tr>
            <td class="table-cell align-start">Escolas em comunidades indigenas</td>
            <td class="table-cell">
              <input
                class="display-input"
                value="{{ dados.pqrFatorPondIndigena }}"
              />
            </td>
          </tr>
          <tr>
            <td class="table-cell align-start">Escolas em comunidades quilombolas</td>
            <td class="table-cell">
              <input
                class="display-input"
                value="{{ dados.pqrFatorPondQuilombola }}"
              />
            </td>
          </tr>
          <tr>
            <td class="table-cell align-start">Atendimento Educacional Especializado (AEE)</td>
            <td class="table-cell">
              <input
                class="display-input"
                value="{{ dados.pqrFatorPondAee }}"
              />
            </td>
          </tr>
          <tr>
            <td class="table-cell align-start">Ensino Médio Integrado à Educação Profissional</td>
            <td class="table-cell">
              <input
                class="display-input"
                value="{{ dados.pqrFatorPondEnsMedioProfissional }}"
              />
            </td>
          </tr>
          <tr>
            <td class="table-cell align-start">EJA Integrada à Educação Profissional</td>
            <td class="table-cell">
              <input
                class="display-input"
                value="{{ dados.pqrFatorPondEjaProfissional }}"
              />
            </td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
